// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
  HAMBURGER: '[data-fragment="Header.hamburger"]',
  BACKDROP: '[data-fragment="Header.backdrop"]',
  SEARCH_TRIGGER: '[data-fragment="Header.searchTrigger"]',
  SEARCH_CLOSE: '[data-fragment="Header.searchClose"]',
};

export default class Header extends WebComponent {
  constructor(props) {
    super(props);

    this.state = {
      menuOpened: false,
      searchOpened: false,
      somethingOpened: false,
      headerScrolled: false,
      headerHidden: false,
    };

    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.openSearch = this.openSearch.bind(this);
    this.closeSearch = this.closeSearch.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  didMount() {
    this.on('click', fragments.HAMBURGER, this.toggleMenu);
    this.on('click', fragments.BACKDROP, this.closeMenu);
    this.on('click', fragments.BACKDROP, this.closeSearch);
    this.on('click', fragments.SEARCH_TRIGGER, this.openSearch);
    this.on('click', fragments.SEARCH_CLOSE, this.closeSearch);
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
    this.lastScrollY = 0;

    const navLinksScrollToHref = document.querySelectorAll('.header-nav__link[data-action="scrollToHref"]');
    if(navLinksScrollToHref.length > 0) {
      navLinksScrollToHref.forEach(link => {
        link.addEventListener('click', this.closeMenu);
      });
    }
  }

  toggleMenu = () => {
    const { menuOpened, somethingOpened } = this.state;
    this.setState({
      menuOpened: !menuOpened,
      somethingOpened: !somethingOpened,
    });
  };

  closeMenu = () => {
    this.setState({
      menuOpened: false,
      somethingOpened: false,
    });
  };

  openSearch = () => {
    document.querySelector('#query').focus();
    this.setState({
      searchOpened: true,
      menuOpened: false,
      somethingOpened: true,
    });
  };

  closeSearch = () => {
    this.setState({
      searchOpened: false,
      somethingOpened: false,
    });
  };

  handleScroll = () => {
    const scrollY = window.scrollY;
    if (window.scrollY > 50) {
      this.setState({
        headerScrolled: true,
      });
      if (scrollY > this.lastScrollY) {
        this.setState({
          headerHidden: true,
        });
      } else {
        this.setState({
          headerHidden: false,
        });
      }
    } else {
      this.setState({
        headerScrolled: false,
      });
    }
    this.lastScrollY = scrollY <= 0 ? 0 : scrollY;
  };

  handleResize = () => {
    if (window.innerWidth > 1399 && this.state.menuOpened) {
      this.closeMenu();
    }
  };

  willUnMount() {}
  update() {
    const {
      menuOpened,
      searchOpened,
      somethingOpened,
      headerScrolled,
      headerHidden,
    } = this.state;
    classNames(this.element, { 'header--menu-opened': menuOpened });
    classNames(this.element, { 'header--search-opened': searchOpened });
    classNames(this.element, { 'header--scrolled': headerScrolled });
    classNames(this.element, { 'header--hidden': headerHidden });
    classNames(document.body, { 'header__body-overflow': somethingOpened });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Header.js